import api from '../../utils/axiosInstance';

// Register new user
export const registerUser = async (userData) => {
  try {
    const response = await api.post('/users/register', userData);
    return response.data;
  } catch (error) {
    console.error('Server Response:', error.response?.data || error.message);
    throw error;
  }
};

// Complete user profile (attach agence, company, role, etc.)
export const completeUserProfile = async (userId, profileData) => {
  try {
    const response = await api.patch(`/users/complete-profile/${userId}`, profileData);
    return response.data;
  } catch (error) {
    console.error('Server Response:', error.response?.data || error.message);
    throw error;
  }
};

// Get all users linked to a company
export const getUsersWithCompany = async () => {
  try {
    const response = await api.get('/users/with-company');
    return response.data;
  } catch (error) {
    console.error('Server Response:', error.response?.data || error.message);
    throw error;
  }
};

export const getUserPreferences = async () => {
  try {
    const response = await api.get('/users/preferences');
    return response.data;
  } catch (error) {
    console.error('Server Response:', error.response?.data || error.message);
    throw error;
  }
};

export const updateUserPreferences = async (payload) => {
  try {
    const response = await api.patch('/users/preferences', payload);
    return response.data;
  } catch (error) {
    console.error('Server Response:', error.response?.data || error.message);
    throw error;
  }
};

// Optionally: Get user by id
export const getUserById = async (id) => {
  try {
    const response = await api.get(`/users/${id}`);
    return response.data;
  } catch (error) {
    console.error('Server Response:', error.response?.data || error.message);
    throw error;
  }
};

// Search company by name and account number
export const searchCompany = async (name, accountNumber) => {
  try {
    const response = await api.get('/company/search', {
      params: { name, accountNumber },
    });
    return response.data;
  } catch (error) {
    console.error('Server Response:', error.response?.data || error.message);
    throw error;
  }
};
export const getUsersByAgence = async (agenceId) => {
  try {
    const response = await api.get(`/users/by-agence/${agenceId}`);
    return response.data;
  } catch (error) {
    console.error('Server Response:', error.response?.data || error.message);
    throw error;
  }
};

// Create company and its admin user
export const createCompanyWithAdmin = async (payload) => {
  try {
    const response = await api.post('/company/with-admin', payload);
    return response.data;
  } catch (error) {
    console.error('Server Response:', error.response?.data || error.message);
    throw error;
  }
};

//get company with user info
export const getCompanyById = async (id) => {
  try {
    const response = await api.get(`/company/${id}`);
    return response.data;
  } catch (error) {
    console.error('Server Response:', error.response?.data || error.message);
    throw error;
  }
};



// Update company and its admin user
export const updateCompanyWithAdmin = async (id, payload) => {
  try {
    const response = await api.patch(`/company/${id}/with-admin`, payload);
    return response.data;
  } catch (error) {
    console.error('Server Response:', error.response?.data || error.message);
    throw error;
  }
};

export const getCompanyTheme = async (id) => {
  try {
    const response = await api.get(`/company/${id}/theme`);
    return response.data;
  } catch (error) {
    console.error('Server Response:', error.response?.data || error.message);
    throw error;
  }
};

export const updateCompanyTheme = async (id, theme) => {
  try {
    const response = await api.patch(
      `/company/${id}/theme`,
      { theme }, // { theme: 'DEFAULT' | 'CUSTOM' }
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Server Response:', error.response?.data || error.message);
    throw error;
  }
};

export const getCurrentUser = async () => {
  try {
    const response = await api.get('/users/me');
    return response.data;
  } catch (error) {
    console.error('Server Response:', error.response?.data || error.message);
    throw error;
  }
};
